import React from 'react'
import fractalsUtilClass from './fractalsUtil.js'
import sierpinskiTriangleClass from './sierpinskiTriangle.js'
import Raphael from 'raphael'

class Fractals extends React.Component {
  componentDidMount() {
    if (typeof window !== `undefined` || typeof document !== `undefined`) {
      // draw a row of triangles
      const fractalsUtil = fractalsUtilClass()
      const sierpinskiTriangle = sierpinskiTriangleClass()
      window.fractalsUtil = fractalsUtil
      // how many drawings in a row
      let TRIANGLE_ROW_COUNT = 4
      let TRIANGLE_CANVAS_HEIGHT = 400
      let paper1 = new Raphael('canvas-1', '100%', TRIANGLE_CANVAS_HEIGHT)
      let maxLevel = 6
      let baseFractalFunction = sierpinskiTriangle.getSierpinskiTriangle
      let redrawSierpinskiTriangleFractals = function() {
        paper1.clear()
        let sierpinskiTriangleFractals = fractalsUtil.drawFractalRow(
          paper1,
          TRIANGLE_ROW_COUNT,
          maxLevel,
          sierpinskiTriangle.getSierpinskiTriangle,
          baseFractalFunction
        )
      }
      redrawSierpinskiTriangleFractals()
    }
  }
  render() {
    return (
      <div
        id="canvas-1"
        className="canvas"
        style={{
          width: '48vw',
          height: '400px',
          marginLeft: '2vw',
        }}
      />
    )
  }
}

export default Fractals



// WEBPACK FOOTER //
// ./src/components/fractals/index.jsx